<shared-ui-modal-base-modal
  [title]="'modal-download-all-files-from-folder-title' | translate"
  [cancelButtonTitle]="'button-close' | translate"
  [canConfirm]="true"
  [closeOnConfirm]="false"
  [confirmButtonTitle]="'button-send-request' | translate"
  [confirmButtonDisabled]="downloadAllFormGroup.invalid || settingsFetched === false"
  (confirmOutput)="onSendRequest()"
>
  <div *ngIf="hasLockedEvidence" class="row justified pt-2">
    <div class="col-sm-2"></div>
    <label class="col-sm-10 alert alert-warning form-label fw-bold">{{ 'modal-download-all-files-from-folder-warning' | translate }}</label>
  </div>
  <div class="row justified pt-2">
    <div class="col-sm-2"></div>
    <label class="col-sm-10 form-label fw-bold">{{ 'modal-download-all-files-from-folder-explanation' | translate }}</label>
  </div>
  <br />
  <shared-ui-inputs-input-group
    [id]="'agree-field'"
    [parentFormGroup]="downloadAllFormGroup"
    [formName]="'agreement'"
    [name]="'input-agree' | translate"
    [display]="inputDisplay.Inline"
  ></shared-ui-inputs-input-group>
  <br />
  <shared-ui-inputs-text-group
    [parentFormGroup]="downloadAllFormGroup"
    [formName]="'reason'"
    [name]="'input-reason' | translate"
    [numRows]="7"
    [display]="inputDisplay.Inline"
    [disabled]="settingsFetched === false"
    [placeholder]="'modal-download-all-files-from-folder-reason' | translate"
  ></shared-ui-inputs-text-group>
</shared-ui-modal-base-modal>
